// extracted by mini-css-extract-plugin
export default {"feefoSnippetsWrapper":"feefo-highlighted-snippets__feefoSnippetsWrapper___1_W6F"};